// src/PublicUser/components/tools/ToolsHero.jsx
import React from 'react';
import '../../css/ToolsHero.css';

export default function ToolsHero({ searchQuery, setSearchQuery, stats, showFavsOnly, setShowFavsOnly, favCount }) {
  return (
    <section className="ts-tools-hero">
      <div className="ts-tools-hero-inner">
        <div className="ts-tools-title-area">
          <h1>Explore <span>AI Tools</span></h1>
          <p>Discover powerful AI tools to boost productivity, creativity, and development workflows.</p>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', alignItems: 'center', justifyContent: 'space-between' }}>
          <div className="ts-tools-search-bar">
            <span className="ts-tools-search-icon">🔍</span>
            <input
              type="text"
              className="ts-tools-input"
              placeholder="Search software setup..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="ts-tools-stats-strip">
            <div className="ts-tools-stat-pill">All: <span className="ts-tools-stat-count">{stats.total}</span></div>
            <div className="ts-tools-stat-pill" style={{ color: 'var(--tools-free)' }}>Free: <span className="ts-tools-stat-count">{stats.free}</span></div>
            <div className="ts-tools-stat-pill" style={{ color: 'var(--tools-freemium)' }}>Free + Paid: <span className="ts-tools-stat-count">{stats.freemium}</span></div>
            <div className="ts-tools-stat-pill" style={{ color: 'var(--tools-paid)' }}>Paid: <span className="ts-tools-stat-count">{stats.paid}</span></div>

            <button 
              className={`ts-tools-fav-toggle ${showFavsOnly ? 'ts-active' : ''}`}
              onClick={() => setShowFavsOnly(!showFavsOnly)}
            >
              <span>{showFavsOnly ? '★ Bookmarks Only' : '☆ Bookmarks'}</span>
              <span className="ts-tools-stat-count" style={{ background: showFavsOnly ? '#facc15' : '#cbd5e1' }}>
                {favCount}
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}